import React from 'react'
import { Button, Stack } from '@mui/material'
import { ActionDialogButtonProps } from './_props'
import { generateRandomGuiID } from '../../../utils/commonUtils'
import sxs from './_sxs'

const ActionDialogButtons: React.FC<ActionDialogButtonProps> = ({ buttons }) => (
    <Stack flexDirection="row" justifyContent="flex-end" gap="1rem" sx={sxs.actionDialogButtonContainer}>
        {buttons.map((button, idx) => (
            <Button
                key={generateRandomGuiID()}
                sx={[
                    sxs.actionDialogButtonBase,
                    idx === buttons.length - 1 ? sxs.actionDialogButtonDarkVariant : sxs.actionDialogButtonLightVariant,
                ]}
                endIcon={button.icon}
                onClick={() => button?.action()}
            >
                {button.label}
            </Button>
        ))}
    </Stack>
)

export default ActionDialogButtons
